import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Tooltip } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

export default function DashboardBackButton({
    to = '/dashboard',
    title = 'Torna alla dashboard',
    boxSx,
    buttonSx,
}) {
    const navigate = useNavigate();

    const baseBoxSx = { px: { xs: 1, sm: 2 }, pt: { xs: 1, sm: 2 } };
    const baseBtnSx = {
        color: '#99191b',
        backgroundColor: 'rgba(153,25,27,0.08)',
        border: '1px solid rgba(153,25,27,0.18)',
        '&:hover': { backgroundColor: 'rgba(153,25,27,0.14)' },
    };

    return (
        <Box sx={{ ...baseBoxSx, ...(boxSx || {}) }}>
            <Tooltip title={title}>
                <IconButton
                    onClick={() => navigate(to)}
                    aria-label={title}
                    sx={{ ...baseBtnSx, ...(buttonSx || {}) }}
                >
                    <ArrowBack />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
